import React from 'react';

export const zcTexts = {
  title: {
      ko: (
        <>
          초고속 암호화 솔루션
        </>
      ),
      en: (
        <>
          Ultra-Fast Encryption Solution
        </>
      )
  },
  subtitle: {
      ko: (
        <>
          ZONECENTRAL
        </>
      ),
      en: (
        <>
          ZONECENTRAL
        </>
      )
  }
};

export const outlineTexts = {
  title: {
      ko: (
        <>
          ZONECENTRAL 개요
        </>
      ),
      en: (
        <>
          ZONECENTRAL Overview
        </>
      )
  },
  subtitle: {
      ko: (
        <>
          SafetyZone Management System(SZMS)
        </>
      ),
      en: (
        <>
          SafetyZone Management System(SZMS)
        </>
      )
  },
  message: {
      ko: (
        <>
          보다 획기적인 Cyber Security 보안성 강화를 위하여 새로운 개념의 SZMS를 제안합니다.
          <br />SZMS는 기업의 다양한 파일을 “안전지대”와 “위험지대”로 구분하여,
          “보안성” 및 “업무 편의성“ 획기적으로 개선할 수 있도록 설계되었습니다.
          </>
      ),
      en: (
        <>
          We propose a new concept of SZMS to enhance the security of Cyber Security.
          <br />SZMS is designed to significantly improve "security" and "work convenience"
          by classifying various files of the company into "safe zones" and "danger zones".
        </>
      )
  }
};

export const specialTexts = {
  title: {
      ko: (
        <>
          ZONECENTRAL 특징
        </>
      ),
      en: (
        <>
          ZONECENTRAL Features
        </>
      )
  },
  kerneltitle: {
      ko: (
        <>
          초고속 커널 드라이버 암호화
        </>
      ),
      en: (
        <>
          Ultra-Fast Kernel Driver Encryption
        </>
      )
  },
  kernelmessage: {
      ko: (
        <>
          초고속으로 ZONECENTRAL 파일 암호화
          <br />파일 종류, 파일 크기와 상관 없는 초고속 암호화
          <br />업무에 영향을 주지 않는 암호화 수행
        </>
      ),
      en: (
        <>
          Ultra-fast encryption of ZONECENTRAL files
          <br />Ultra-fast encryption regardless of file type and size
          <br />Encryption performed without affecting work
        </>
      )
  },
  processtitle: {
      ko: (
        <>
          인증 프로세스 접근
        </>
      ),
      en: (
        <>
          Access to the authentication process
        </>
      )
  },
  processmessage: {
      ko: (
        <>
          SafetyZone에 등록된 파일은 허가된 프로세스만 접근 가능
          <br />허가되지 않은 프로세스는 접근할 수 없음
          <br />악성코드로 부터 안전하게 파일 보호 가능
          </>
      ),
      en: (
        <>
          Files registered in the SafetyZone can only be accessed by authorized processes
          <br />Unauthorized processes cannot access them
          <br />Files can be safely protected from malware by accessing them safely
        </>
      )
  },
  containertitle: {
      ko: (
        <>
          안전 보장 암호화 컨테이너
        </>
      ),
      en: (
        <>
          Safety Guarantee Encryption Container
        </>
      )
  },
  containermessage: {
      ko: (
        <>
          파일을 이동할 때 암호화 컨테이너로 이동
          <br />암호화 컨테이너는 복호화 인증키 포함
          <br />Windows 팝업 메뉴 간단히 생성
          </>
      ),
      en: (
        <>
          When moving files, they are moved to an encrypted container
          <br />The encrypted container includes a decryption authentication key
          <br />Easily created through the Windows popup menu
        </>
      )
  },
  allfiletitle: {
      ko: (
        <>
          모든 파일 암호화
        </>
      ),
      en: (
        <>
          All File Encryption
        </>
      )
  },
  allfilemessage: {
      ko: (
        <>
          파일을 이동할 때 암호화 컨테이너로 이동
          <br />암호화 컨테이너는 복호화 인증키 포함
          <br />Windows 팝업 메뉴 간단히 생성
          </>
      ),
      en: (
        <>
          When moving files, they are moved to an encrypted container
          <br />The encrypted container includes a decryption authentication key
          <br />Easily created through the Windows popup menu
        </>
      )
  },
  table: {
    header: {
      ko: ['파일종류', '확장자', '지원'],
      en: ['File Type', 'Extension', 'Support']
    },
    rows: [
      {
        ko: ['MS Office 파일', 'Word, Excel, PowerPoint 등', '●'],
        en: ['MS Office', 'Word, Excel, PowerPoint', '●']
      },
      {
        ko: ['한글 파일', 'HWP 등', '●'],
        en: ['Hangul', 'HWP', '●']
      },
      {
        ko: ['전자문서 파일', 'PDF 등', '●'],
        en: ['E-Document', 'PDF', '●']
      },
      {
        ko: ['CAD 설계 파일', 'DWG, DXF 등', '●'],
        en: ['CAD Design', 'DWG, DXF', '●']
      },
      {
        ko: ['동영상 파일', 'MP4, AVI 등', '●'],
        en: ['Video', 'MP4, AVI', '●']
      },
      {
        ko: ['이미지 파일', 'JPG, PNG 등', '●'],
        en: ['Image', 'JPG, PNG', '●']
      },
      {
        ko: ['텍스트 파일', 'TXT 등', '●'],
        en: ['Text', 'TXT', '●']
      }
    ]
  }
};

export const functionTexts = {
    title: {
      ko: (
        <>
          ZONECENTRAL 주요기능
        </>
      ),
      en: (
        <>
          ZONECENTRAL Key Features
        </>
      )
  },
  functions: [
    {
      title: {
        ko: 'Safetyzone 구축',
        en: 'Build Safetyzone'
      },
      desc: {
        ko: '안전한 파일 사용을 위해 영역을 지정하여 Safetyzone을 구축합니다. Safetyzone을 구축하면 안전하게 파일을 암호화하여 저장할 수 있습니다. Safetyzone에 등록되는 모든 파일은 암호화되어 저장됩니다.',
        en: 'Designate an area to build a Safetyzone for secure file usage. All files registered in the Safetyzone are encrypted and stored safely.'
      }
    },
    {
      title: {
        ko: '사용 인증',
        en: 'User Authentication'
      },
      desc: {
        ko: 'Safetyzone에 등록된 파일을 사용하기 위해서는 반드시 사용자 인증이 필요합니다. 인증키는 사용자가 직접 만들어 사용할 수 있으며, 인증키를 분실했을 경우 관리자에게 연락하여 임시키를 발급받을 수 있습니다. 인증된 사용자만 파일을 열람하고 사용할 수 있습니다.',
        en: 'User authentication is required to use files registered in the Safetyzone. Only authenticated users can view and use files.'
      }
    },
    {
      title: {
        ko: '사용 통제',
        en: 'User Control'
      },
      desc: {
        ko: 'Safetyzone에 등록된 파일은 사용자가 지정한 프로그램에서만 열 수 있습니다. 예를 들어, Safetyzone에 등록된 워드 파일은 Microsoft Word에서만 열 수 있으며, 다른 프로그램에서는 열 수 없습니다. 이를 통해 파일의 안전한 사용을 보장합니다.',
        en: 'Files registered in the Safetyzone can only be opened with the programs specified by the user. For example, a Word file registered in the Safetyzone can only be opened with Microsoft Word, ensuring safe file usage.'
      }
    },
    {
      title: {
        ko: 'ZED 파일 이동',
        en: 'XZED File Transfer'
      },
      desc: {
        ko: 'ZED 파일은 안전하게 암호화된 파일로, Safetyzone에 등록된 파일을 이동할 때 사용됩니다. ZED 파일은 안전하게 암호화되어 있어, 다른 시스템으로 이동하더라도 안전하게 보호됩니다.',
        en: 'ZED files are securely encrypted files used when moving files registered in the Safetyzone. ZED files are securely encrypted, ensuring protection even when moved to other systems.'
      }
    },
    {
      title: {
        ko: 'XZED 파일 이동',
        en: 'XZED File Transfer'
      },
      desc: {
        ko: 'XZED 파일은 ZED 파일의 확장 버전으로, 추가적인 보안 기능을 제공합니다. XZED 파일은 ZED 파일과 동일하게 안전하게 암호화되어 있으며, 추가적인 보안 기능을 통해 더욱 안전한 파일 이동을 지원합니다.',
        en: 'XZED files are an extended version of ZED files, providing additional security features. XZED files are securely encrypted like ZED files, and the additional security features support even safer file transfers.'
      }
    },
    {
      title: {
        ko: '로그 및 통계',
        en: 'Logs and Statistics'
      },
      desc: {
        ko: '모든 파일 사용 기록은 안전하게 기록되며, 이를 통해 파일 사용 통계를 확인할 수 있습니다. 관리자는 파일 사용 기록을 통해 누가, 언제, 어떤 파일을 사용했는지 확인할 수 있으며, 이를 통해 파일 사용의 투명성을 보장합니다.',
        en: 'All file usage records are securely logged, allowing for file usage statistics to be reviewed. Administrators can check who accessed which files and when, ensuring transparency in file usage.'
      }
    }
  ]
};

export const zcUsecaseTexts = {
  title: {
      ko: (
        <>
          사용 사례
        </>
      ),
      en: (
        <>
          Use case
        </>
      )
  },
  motor: {
      ko: (
        <>
          자동차
        </>
      ),
      en: (
        <>
          Automotive
        </>
      )
  },
  motortitle: {
      ko: (
        <>
          데이터 도난 및 유출로부터 워크스테이션 보호
        </>
      ),
      en: (
        <>
          PROTECTING WORKSTATIONS AGAINST DATA THEFT AND LEAKAGE
        </>
      )
  },
  motorsubtitle: {
      ko: (
        <>
          프랑스의 대형 자동차 제조업체 사례
        </>
      ),
      en: (
        <>
          Case of a major French motor manufacturer
        </>
      )
  },
  airport: {
      ko: (
        <>
          공항
        </>
      ),
      en: (
        <>
          Airport
        </>
      )
  },
  airporttitle: {
      ko: (
        <>
          공항의 기밀 데이터 보호
        </>
      ),
      en: (
        <>
          PROTECTING AN AIRPORT’S CONFIDENTIAL DATA
        </>
      )
  },
  airportsubtitle: {
      ko: (
        <>
          유럽 대륙으로 향하는 주요 관문인 국제공항 허브 사례
        </>
      ),
      en: (
        <>
          Case of an international airport hub, a major gateway to the European continent
        </>
      )
  },
  medical: {
      ko: (
        <>
          의료
        </>
      ),
      en: (
        <>
          Medical
        </>
      )
  },
  medicaltitle: {
      ko: (
        <>
          의료 기록 보안
        </>
      ),
      en: (
        <>
          SECURING MEDICAL RECORDS
        </>
      )
  },
  medicalsubtitle: {
      ko: (
        <>
          씬 클라이언트를 사용하여 환자 파일을 보호하고 상담
        </>
      ),
      en: (
        <>
          Case of a hospital: protecting patient files, consulted using a fleet of thin clients
        </>
      )
  },
  edu: {
      ko: (
        <>
          교육
        </>
      ),
      en: (
        <>
          Education
        </>
      )
  },
  edutitle: {
      ko: (
        <>
          시험지의 비밀 보장
        </>
      ),
      en: (
        <>
          GUARANTEEING THE CONFIDENTIALITY OF EXAM PAPERS
        </>
      )
  },
  edusubtitle: {
      ko: (
        <>
          프랑스 지역 교육청 사례
        </>
      ),
      en: (
        <>
          Case of a regional education authority in France
        </>
      )
  },
  edudownload: {
      ko: (
        <>
          다운로드 받기
        </>
      ),
      en: (
        <>
          Download
        </>
      )
  }

};

export const certTexts = {
  title: {
      ko: (
        <>
          인증
        </>
      ),
      en: (
        <>
          Certifications
        </>
      )
  }
};